import { ChunkProgressBar } from '@progress/kendo-react-progressbars';
import { Cache } from 'aws-amplify';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import NewPatientBilling from '../components/patients/NewPatientBilling';
import { PaymentFrequency } from '../components/patients/PaymentFrequency';
import { PaymentMethod } from '../components/patients/PaymentMethods';
import useLanguage from '../hooks/use-language';
import { signup } from '../intl/signup';
import { createPatientBilling } from '../services/patient-service';
import { NEW_PATIENT_KEY } from "./MultiPatientSetup";

export type SimplePatientBillingProps = RouteComponentProps<{ practiceId: string }> & {}

/**
 * 1. create billing records for the first patient w/o paying patient id, and with token and stuff
 *    this happens in the NewPatientBilling component
 * 2. create billing records for the rest using paying patient id of the first one
 * 3. save the rest of the patient histories
 * 4. redirect to thankyou
 */
const SimplePatientBilling: React.SFC<SimplePatientBillingProps> = ({ match }) => {
  const practiceId = match.params.practiceId;
  const language = useLanguage();
  const cachedPatients: any = Cache.getItem(NEW_PATIENT_KEY);
  const [progress, setProgress] = useState(0);

  if (cachedPatients?.length === 0) {
    return (
      <div className="w-100 h-100">
        <h1>It looks like something went wrong.</h1>
        <h2>Please go back and enter the patient information.</h2>
      </div>
    );
  }
  const firstPatient = cachedPatients[0]?.saved;

  const onSuccess = async (data: any) => {
    // save billing record for all the other patients
    for (const pat of cachedPatients) {
      const patient = pat?.saved;
      if (patient.patientId !== firstPatient.patientId) {
        console.log('Keen: onSuccess -> patient', patient);
        const billing = await createPatientBilling(
          practiceId,
          patient.patientId,
          `${patient.firstName} ${patient.lastName}`,
          patient.email,
          PaymentMethod.PATIENT,
          '',
          firstPatient.patientId,
          data.subscriptionPaymentFrequency,
          data.customerId
        );
        console.debug('Keen: onSuccess -> saved billing success', billing?.patientId, billing);
      }
      setProgress(old => old + 1);
    }
  }

  const chunks = cachedPatients.length * 2;
  if (progress > 0) {
    return (
      <Row className="w-100 justify-content-center align-items-center">
        <ChunkProgressBar value={100 * progress / chunks} chunkCount={chunks} />
      </Row>
    )
  }
  return (
    <div className="p-4 m-auto simple-payment d-flex align-items-center justify-content-center flex-column">
      <h2 className="text-center">{signup.almostDone[language]}</h2>
      <Row>
        <Col>
          <NewPatientBilling
            patientId={firstPatient?.patientId}
            onSaveSuccess={onSuccess}
            patientEmail={firstPatient?.email}
            patientName={`${firstPatient?.firstName} ${firstPatient?.lastName}`}
            selectedPaymentFrequency={PaymentFrequency.MONTH}
          />
        </Col>
      </Row>
    </div>
  );
}

export default SimplePatientBilling;
